// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1LdxT","choiceBoxes":"toolbarselects_choiceBoxes__2dfTJ","simpleField":"toolbarselects_simpleField__1JZSn"};